module.exports = __webpack_public_path__ + "img/ic_l@2x.2d2efbb7.png";